@let presentOverflowActions = builderStore.presentOverflowActionsSg();

@if (presentOverflowActions) {
  @let origin = originSg();

  <atn-ds-attached-overlay
    [offsetY]="-10"
    [origin]="origin"
    (backdropClick)="backdropClickHandler()"
  >
    <div class="atn-page-builder-overflow-actions">
      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="addSegmentClickHandler()"
      >
        <i class="atn-icon atn-add-segment atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">
          Add Segment
        </div>
      </div>

      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="addWidgetClickHandler()"
      >
        <i class="atn-icon atn-add-widget atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">
          Add Widget
        </div>
      </div>

      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="optimizeLayout()"
      >
        <i class="atn-icon atn-broom atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">
          Cleanup
        </div>
      </div>

      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="configurePageClickHandler()"
      >
        <i class="atn-icon atn-settings atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">
          Configure Page
        </div>
      </div>

      <!-- TODO Uncomment once we have logic for testing variables -->
      <!-- <div class="atn-page-builder-overflow-actions__action">
          <i class="atn-icon atn-funnel atn-light"></i>
          <div class="atn-page-builder-overflow-actions__action-name">
            Test Variables
          </div>
        </div> -->

      <hr />

      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="cancelButtonClickHandler()"
      >
        <i class="atn-icon atn-cancel atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">Cancel</div>
      </div>

      <div
        class="atn-page-builder-overflow-actions__action"
        (click)="saveButtonClickHandler()"
      >
        <i class="atn-icon atn-save atn-light"></i>
        <div class="atn-page-builder-overflow-actions__action-name">Save</div>
      </div>
    </div>
  </atn-ds-attached-overlay>
}
